module.exports = __webpack_public_path__ + "img/Group_27918.16dc2c2b.png";